<template>
    <section class="more-from-carousel">
        <header class="component-header container hd-container">
            <h2 class="headline-1">More From CAC</h2>
        </header>
        <div class="hd-container">
            <GlobalCarousel padding="20%" :items="items" :fullWidth="false">
                <template #item="item">
                    <CardsTextOverImage :item="item" />
                </template>
            </GlobalCarousel>
        </div>
    </section>
</template>

<script setup>
    const items = ref([
        {
            title: 'Membership',
            image: '/img/more-from/membership.jpg',
            url: 'https://www.architecture.org/join-and-support/membership',
            internal: true,
        },
        {
            title: 'Other City Tours',
            image: '/img/more-from/other-tours.jpg',
            url: 'https://www.architecture.org/city-tours',
            internal: true,
        },
        {
            title: 'Visit the Center',
            image: '/img/more-from/visit-the-center.jpg',
            url: 'https://www.architecture.org/visit-the-center',
            internal: true,
        },
    ]);
</script>

<style lang="scss">
    .more-from-carousel {
        padding-top: 30px;
        margin-bottom: 55px;

        .carousel-component {
            .carousel-inner {
                @media (min-width: $tablet) {
                    padding-right: 0px !important;
                }

                .carousel-item {
                    flex: 0 0 50%;

                    @media (min-width: $tablet) {
                        flex: 0 0 32.4%;
                        padding: 0px 8px;
                    }
                }
            }

            .arrow {
                display: none;
            }
        }
    }
</style>
